import * as React from 'react';
import {connect} from "react-redux";
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {USER_GUIDE_URL} from '../../Config/userGuideConfig';
import {URL} from '../../Config/appConfig';
import {RecordCount, InsurerId, ReduxUpdatedState} from '../../Config/dataModel';
import coverNoteDispatch from '../../ReduxRequests/Dispatch/coverNoteDispatch';
import policyDispatch from '../../ReduxRequests/Dispatch/policyDispatch';
import authState from '../../ReduxRequests/State/authState';
import coverNoteState from '../../ReduxRequests/State/coverNoteState';
import policyState from '../../ReduxRequests/State/policyState';
import MaintenanceNotification from '../Maintenance/MaintenanceNotification';
import Grid from '@material-ui/core/Grid';
import * as moment from 'moment';
import '../../style/dashboard.css';

const coverNoteIcon = require('../../resource/img/covernote-default.svg');
const policyIcon = require('../../resource/img/policy-default.svg');
const contactIcon = require('../../resource/img/contact-default.svg');
const searchIcon = require('../../resource/img/search-default.svg');
const createIcon = require('../../resource/img/create-default.svg');
const batchIcon = require('../../resource/img/batch-default.svg');

const mapDispatchToProps = (dispatch) => {
    return {
        ...coverNoteDispatch(dispatch),
        ...policyDispatch(dispatch)
    }
};

const mapStateToProps = (state) => {
    return {
        ...coverNoteState(state),
        ...policyState(state),
        ...authState(state)
    }
};

interface DashboardProps {
    newCount?: RecordCount,
    insurerId: () => InsurerId,
    coverNoteCount: ReduxUpdatedState,
    policyCount: ReduxUpdatedState,
    fetchCoverNoteCount: (insurerId: InsurerId) => void,
    fetchPolicyCount: (insurerId: InsurerId) => void
}

interface DashboardState {
    coverNoteCount: string,
    policyCount: string
}

class Dashboard extends React.Component<RouteComponentProps & DashboardProps, DashboardState> {
    public unlisten: any;
    public componentMountedAt : moment.Moment = moment();

    public constructor(props: DashboardProps) {
        super(props);
        this.state = this.getInitialState();
    }

    public getInitialState() {
        return {
            coverNoteCount: '-',
            policyCount: '-'
        };
    }

    public componentWillMount() {
        this.unlisten = this.props.history.listen((location, action) => {
            if (location.state && location.state.insurerChanged) {
                this.setState(this.getInitialState());
                this.getContent();
            }
        });
    }

    public componentDidMount() {
        this.getContent();
    }

    public componentWillUnmount() {
        this.unlisten();
    }

    public componentWillReceiveProps(nextProps: DashboardProps) {
        if (nextProps.coverNoteCount && nextProps.coverNoteCount.updatedAt.isAfter(this.componentMountedAt) && nextProps.coverNoteCount.value.toString() !== this.state.coverNoteCount) {
            this.setState({
                coverNoteCount: nextProps.coverNoteCount.value.toString()
            });
        }
        if (nextProps.policyCount && nextProps.policyCount.updatedAt.isAfter(this.componentMountedAt) && nextProps.policyCount.value.toString() !== this.state.policyCount) {
            this.setState({
                policyCount: nextProps.policyCount.value.toString()
            });
        }
        if (nextProps.newCount !== this.props.newCount) this.updateCount(nextProps.newCount);
    }

    public updateCount(data: RecordCount) {
        let coverNoteCount = this.state.coverNoteCount;
        if (this.state.coverNoteCount !== '-') coverNoteCount = (parseInt(coverNoteCount, 10) + data.coverNote).toString();
        let policyCount = this.state.policyCount;
        if (this.state.policyCount !== '-') policyCount = (parseInt(policyCount, 10) + data.policy).toString();
        this.setState({
            coverNoteCount,
            policyCount
        });
    }

    public getContent() {
        this.props.fetchCoverNoteCount(this.props.insurerId());
        this.props.fetchPolicyCount(this.props.insurerId());
    }

    public clickButton(dest: string) {
        this.props.history.push({
            pathname: dest,
            state: {
                fromDashboard: true
            }
        });
    }

    public render() {
        return (
            <div className="cmHorCenter dashboard">
                <div className="dashboardInstruction">
                    <MaintenanceNotification isClearable={true}/>
                    <a href={USER_GUIDE_URL} target="_blank" rel="noreferrer">How to start</a>
                </div>
                <div className="dashboardContainer">
                    <Grid item xs={6}>
                        <button className="dashboardBox largeDashboardBox" onClick={(e) => this.clickButton(URL.COVER_NOTE)}>
                            <div className="cmText title">Cover Note</div>
                            <div className="cmText cmBoldText subTitle">{`${this.state.coverNoteCount} ${this.state.coverNoteCount === '1' ? 'record' : 'records'}`}</div>
                            <div className="dashboardInfoContainer largeDashboardInfoContainer">
                                <div className="cmHorCenter ovalBorder largeOvalBorder"/>
                                <div className="bottomBlueBox largeBottomBlueBox"/>
                                <div className="dashboardInfoArea largeDashboardInfoArea">
                                    <div className="cmHorCenter ovalContainer largeOvalContainer">
                                        <img height="120" width="120" className="dashboardIcon largeDashboardIcon" src={coverNoteIcon}/>
                                    </div>
                                </div>
                            </div>
                        </button>
                    </Grid>
                    <Grid item xs={6}>
                        <button className="dashboardBox largeDashboardBox" onClick={(e) => this.clickButton(URL.POLICY)}>
                            <div className="cmText title">Policy</div>
                            <div className="cmText cmBoldText subTitle">{`${this.state.policyCount} ${this.state.coverNoteCount === '1' ? 'record' : 'records'}`}</div>
                            <div className="dashboardInfoContainer largeDashboardInfoContainer">
                                <div className="cmHorCenter ovalBorder largeOvalBorder"/>
                                <div className="bottomBlueBox largeBottomBlueBox"/>
                                <div className="dashboardInfoArea largeDashboardInfoArea">
                                    <div className="cmHorCenter ovalContainer largeOvalContainer">
                                        <img height="120" width="120" className="dashboardIcon largeDashboardIcon" src={policyIcon}/>
                                    </div>
                                </div>
                            </div>
                        </button>
                    </Grid>
                </div>
                <div className="dashboardContainer">
                    <Grid item xs={3}>
                        <button className="dashboardBox smallDashboardBox" onClick={(e) => this.clickButton(URL.COMPANIES)}>
                            <div className="cmText title">Contact</div>
                            <div className="dashboardInfoContainer smallDashboardInfoContainer">
                                <div className="cmHorCenter ovalBorder smallOvalBorder"/>
                                <div className="bottomBlueBox smallBottomBlueBox"/>
                                <div className="dashboardInfoArea smallDashboardInfoArea">
                                    <div className="cmHorCenter ovalContainer smallOvalContainer">
                                        <img height="90" width="90" className="dashboardIcon smallDashboardIcon" src={contactIcon}/>
                                    </div>
                                </div>
                            </div>
                        </button>
                    </Grid>
                    <Grid item xs={3}>
                        <button className="dashboardBox smallDashboardBox" onClick={(e) => this.clickButton(URL.SEARCH)}>
                            <div className="cmText title">Search</div>
                            <div className="dashboardInfoContainer smallDashboardInfoContainer">
                                <div className="cmHorCenter ovalBorder smallOvalBorder"/>
                                <div className="bottomBlueBox smallBottomBlueBox"/>
                                <div className="dashboardInfoArea smallDashboardInfoArea">
                                    <div className="cmHorCenter ovalContainer smallOvalContainer">
                                        <img height="90" width="90" className="dashboardIcon smallDashboardIcon" src={searchIcon}/>
                                    </div>
                                </div>
                            </div>
                        </button>
                    </Grid>
                    <Grid item xs={3}>
                        <button className="dashboardBox smallDashboardBox" onClick={(e) => this.clickButton(URL.CREATE)}>
                            <div className="cmText title">Create</div>
                            <div className="dashboardInfoContainer smallDashboardInfoContainer">
                                <div className="cmHorCenter ovalBorder smallOvalBorder"/>
                                <div className="bottomBlueBox smallBottomBlueBox"/>
                                <div className="dashboardInfoArea smallDashboardInfoArea">
                                    <div className="cmHorCenter ovalContainer smallOvalContainer">
                                        <img height="90" width="90" className="dashboardIcon smallDashboardIcon" src={createIcon}/>
                                    </div>
                                </div>
                            </div>
                        </button>
                    </Grid>
                    <Grid item xs={3}>
                        <button className="dashboardBox smallDashboardBox" onClick={(e) => this.clickButton(URL.BATCH)}>
                            <div className="cmText title">Batch</div>
                            <div className="dashboardInfoContainer smallDashboardInfoContainer">
                                <div className="cmHorCenter ovalBorder smallOvalBorder"/>
                                <div className="bottomBlueBox smallBottomBlueBox"/>
                                <div className="dashboardInfoArea smallDashboardInfoArea">
                                    <div className="cmHorCenter ovalContainer smallOvalContainer">
                                        <img height="90" width="90" className="dashboardIcon smallDashboardIcon" src={batchIcon}/>
                                    </div>
                                </div>
                            </div>
                        </button>
                    </Grid>
                </div>
            </div>
        );
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Dashboard));



// WEBPACK FOOTER //
// ./src/Components/Dashboard/Dashboard.tsx